export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null; // Mindig térjen vissza valamivel
};

export const API_URL = process.env.REACT_APP_API_URL;

export const handleErrorResponse = async (response, message) => {
    if (!response.ok) {
        if (response.status === 401) {
            localStorage.removeItem('ACCESS_TOKEN');
        }

        const responseJson = await response.json();

        throw new Error(JSON.stringify({
            message: responseJson.message || message,
            code: responseJson.code || null,
            status: response.status
        }));
    }
};
